export const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};

const currentLevel = LOG_LEVELS[window.REACT_APP_LOG_LEVEL];

export const logger = {
  debug: (...args) => currentLevel <= LOG_LEVELS.DEBUG && console.debug(...args),
  info: (...args) => currentLevel <= LOG_LEVELS.INFO && console.info(...args),
  warn: (...args) => currentLevel <= LOG_LEVELS.WARN && console.warn(...args),
  error: (...args) => currentLevel <= LOG_LEVELS.ERROR && console.error(...args),
};

console.debug('[Logger] Initialized with log level:', window.REACT_APP_LOG_LEVEL);
